import {Component, inject, Input, OnInit, signal} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ThaitracesReqLogService} from '../thaitraces-req-log.service';
import {RequestThaitracesAppView} from '../../../../../generated-model/models';

@Component({
  selector: 'app-thaitraces-req-log-app-detail-modal',
  standalone: true,
  imports: [],
  templateUrl: './thaitraces-req-log-app-detail-modal.component.html'
})
export class ThaitracesReqLogAppDetailModalComponent implements OnInit {
  @Input() token!: string;

  private readonly service = inject(ThaitracesReqLogService);
  protected readonly modal = inject(NgbActiveModal);
  protected readonly items = signal<RequestThaitracesAppView[]>([]);
  protected loading = signal(true);

  ngOnInit(): void {
    this.service.getApplicationDetails(this.token).subscribe({
      next: (data) => {
        this.items.set(data);
        this.loading.set(false);
      },
      error: () => this.loading.set(false)
    });
  }

  protected formatJson(json: string | undefined): string {
    if (!json) {
      return '-';
    }
    try {
      return JSON.stringify(JSON.parse(json), null, 2);
    } catch {
      return json;
    }
  }
}
